import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import CreateButton from "components/CustomButtons/CreateButton";
import { makeStyles } from "@mui/styles";
import {
  AutocompleteInput,
  DateInput,
  FloatInput,
  TextInput,
} from "components/Input/Index.js";
import { compte } from "variables/patrimoine.js";

import AdvancedSearchContext from "context/AdvancedSearchContext";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { updateAccountContract , getFiles} from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function EditUtilitiesDialog(props) {
  const [disabled, setDisabled] = useState(true);
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const {
    energy,
    parameters,
    closeModal,
    refetch,
    idSelected,
    clef,
    contractname,
    contractnumber,
    tarifftype,
    name,
    contractbegindate,
    contractenddate,
    billowner,
    contractowner,
    payedby,
    primaryfinalenergyratio,
    co2ratio,
    energycost,
    othermonthlycost,
    otherunitcost,
    comments,
    description,
    ged,
    handleClefChange,
    handleContractnameChange,
    handleContractnumberChange,
    handleTariftypeChange,
    handleNameChange,
    handleContractbegindateChange,
    handleContractenddateChange,
    handleBillownerChange,
    handleContractownerChange,
    handlePayedbyChange,
    handlePrimaryfinalenergyratioChange,
    handleCo2ratioChange,
    handleEnergyunitChange,
    handleEnergycostChange,
    handleOthermonthlycostChange,
    handleOtherunitcostChange,
    handleAssociatedfilesChange,
    handleCommentsChange,
    handleDescriptionChange,
  } = props;

  const selectedGed = () => {
    let gedCardId = [];

    let getGedNames;

    if (ged !== undefined) {
      for (let i = 0; i < ged.length; i++) {
        gedCardId.push(ged[i].fileId);
      }

      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );

    }
    return getGedNames;
  };

  useEffect(() => {
    if (!name || !contractname) {
      setDisabled(true);
    }
    else
      setDisabled(false);
    console.log(disabled);
  }, [name, contractname]);

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const handleSubmit = async (event) => {
    const editedDetails = {
      clef,
      contractname,
      contractnumber,
      tarifftype,
      name,
      contractbegindate,
      contractenddate,
      billowner,
      contractowner,
      payedby,
      primaryfinalenergyratio,
      co2ratio,
      energycost,
      othermonthlycost,
      otherunitcost,
      comments,
      description,
      ged,
    };

    const editedContract = {
      'uuid': idSelected,
      details : editedDetails,
    };

    axios
      .put(
        updateAccountContract(idSelected,chartIdGroup,energy),
        editedContract,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
      })
      .catch(() => { });
  };

  console.log(handleSubmit);

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
              isRequired
                inputTitle={compte.energy[energy][parameters].contractname}
                textInput={contractname}
                handleTextInputChange={handleContractnameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].contractnumber}
                textInput={contractnumber}
                handleTextInputChange={handleContractnumberChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].tarifftype}
                textInput={tarifftype}
                handleTextInputChange={handleTariftypeChange}
              />
            </div>
            <div>
              <TextInput
              isRequired
                inputTitle={compte.energy[energy][parameters].name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.energy[energy][parameters].contractbegindate}
                dateInput={contractbegindate}
                handleDateInputChange={handleContractbegindateChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.energy[energy][parameters].contractenddate}
                dateInput={contractenddate}
                handleDateInputChange={handleContractenddateChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].billowner}
                textInput={billowner}
                handleTextInputChange={handleBillownerChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].contractowner}
                textInput={contractowner}
                handleTextInputChange={handleContractownerChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].payedby}
                textInput={payedby}
                handleTextInputChange={handlePayedbyChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={
                  compte.energy[energy][parameters].primaryfinalenergyratio
                }
                floatInput={primaryfinalenergyratio}
                handleFloatInputChange={handlePrimaryfinalenergyratioChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].co2ratio}
                floatInput={co2ratio}
                handleFloatInputChange={handleCo2ratioChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].energycost}
                floatInput={energycost}
                handleFloatInputChange={handleEnergycostChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].othermonthlycost}
                floatInput={othermonthlycost}
                handleFloatInputChange={handleOthermonthlycostChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={compte.energy[energy][parameters].otherunitcost}
                floatInput={otherunitcost}
                handleFloatInputChange={handleOtherunitcostChange}
              />
            </div>
            <div>
              <AutocompleteInput
                specialWidth="97%"
                inputTitle={compte.energy[energy][parameters].associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
          <CreateButton buttonDisabled={disabled} handleSubmit={handleSubmit} title={'Modifier'}/>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditUtilitiesDialog;
